import { Injectable } from '@angular/core';
//import { GraphQLResult, generateClient } from 'aws-amplify/api';

//import { graphqlOperation } from '@aws-amplify/api-graphql';
import { AppConstants } from './app-constants';
import { environment } from '../../../../../../environments/environment';
import {
  createFuelCreditQueries,
  createFuelMasterQueries,
  filterByFuelMaster,
  filterByFuelMasterQueries,
  getFuelCreditQueries,
  getFuelMasterQueries,
  updateFuelCardDetail,
  updateFuelCreditQueries,
  updateFuelMasterQueries,
  updateFuelMasterStatusQueries,
} from '../../graphql/fuel.queries';
import {
  FuelCreditModel,
  FuelMasterModel,
  InputFuelCredits,
  InputFuelDetails,
} from '../../model/fuelMaster.model';

// const client = generateClient();

import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult, } from "aws-amplify/lib/API/types";
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

//const client = generateClient();

let myAppConfig = environment.myAppConfig;

Amplify.configure(myAppConfig);


@Injectable({
  providedIn: 'root',
})
export class FuelcardService {
  created_date: string;
  updated_date: string;

  fuelCardCreditData = new BehaviorSubject(null);
  private basUrl = environment.smsUrl;
  constructor(
     private httpClient: HttpClient,
  ) {
    this.created_date = this.localDateFormate();
    this.updated_date = this.localDateFormate();
  }

  private QUERY_KEY = {
    Fuel_Master_LIST: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listFuelCardMaster}`,
    Fuel_Master_GET: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.FuelMasterCard}`,
    Fuel_Master_CREATE: `${AppConstants.create}${environment.dbPrefix}${AppConstants.FuelMasterCard}`,
    Fuel_Master_UPDATE: `${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelMasterCard}`,

    Fuel_Card_Detail_LIST: `${AppConstants.list}${environment.dbPrefix}${AppConstants.FuelCardDetails}`,
    Fuel_Card_Detail_GET: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.FuelCardDetails}`,
    Fuel_Card_Detail_CREATE: `${AppConstants.create}${environment.dbPrefix}${AppConstants.FuelCardDetails}`,
    Fuel_Card_Detail_UPDATE: `${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelCardDetails}`,

    Fuel_Credit_LIST: `${AppConstants.list}${environment.dbPrefix}${AppConstants.FuelCardCredit}`,
    Fuel_Credit_GET: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.FuelCardCredit}`,
    Fuel_Credit_CREATE: `${AppConstants.create}${environment.dbPrefix}${AppConstants.FuelCardCredit}`,
    Fuel_Credit_UPDATE: `${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelCardCredit}`,
  };




  localDateFormate() {
    // Assuming mydate is defined as a Date object
    const mydate = new Date();

    // Convert the date to ISO 8601 format including the local time zone offset
    const isoDateString = mydate.toISOString();

    // Alternatively, you can manually format the date string to include the local time zone offset
    const offset = -mydate.getTimezoneOffset(); // Get the offset in minutes
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;
    const offsetSign = offset >= 0 ? '+' : '-';

    const formattedDateString = `${mydate.getFullYear()}-${this.padZero(
      mydate.getMonth() + 1
    )}-${this.padZero(mydate.getDate())}T${this.padZero(
      mydate.getHours()
    )}:${this.padZero(mydate.getMinutes())}:${this.padZero(
      mydate.getSeconds()
    )}${offsetSign}${this.padZero(offsetHours)}:${this.padZero(offsetMinutes)}`;
    console.log(formattedDateString); // Output: 2024-02-14T15:02:01+05:30
    return formattedDateString;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  public async createFuelMasterCard(
    createdObj: any
  ): Promise<InputFuelDetails> {
    const querylist = this.QUERY_KEY.Fuel_Master_CREATE;
    try {
      const operation = graphqlOperation(createFuelMasterQueries.mutation, {
        card_expiry_date: createdObj.card_expiry_date,
        card_number: createdObj.card_number,
        card_provider: createdObj.card_provider,

        // fuel_card_attachments: null,
        status: AppConstants.REQUEST_STATUS.UNASSIGN,

        created_date: `${this.created_date}`,
        updated_date: `${this.updated_date}`,
      });

      // const response: GraphQLResult<{
      //   querylist: InputFuelDetails;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in create fuel master card.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching create fuel master card request status:',
        error
      );
      throw error;
    }
  }

  public async updateFuelMasterCard(
    createdObj: any
  ): Promise<InputFuelDetails> {
    const querylist = this.QUERY_KEY.Fuel_Master_UPDATE;
    try {
      const operation = graphqlOperation(updateFuelMasterQueries.mutation, {
        card_expiry_date: createdObj.card_expiry_date,
        card_number: createdObj.card_number,
        card_provider: createdObj.card_provider,
        id: createdObj.id,
        fuel_card_attachments: [],
        status: AppConstants.REQUEST_STATUS.UNASSIGN,

        // created_date: `${this.created_date}`,
        updated_date: `${this.updated_date}`,
      });

      // const response: GraphQLResult<{
      //   querylist: InputFuelDetails;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in create fuel master card.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching create fuel master card request status:',
        error
      );
      throw error;
    }
  }

  public async getAllFuelCardMaster(nextToken:string | null,limit): Promise<FuelMasterModel> {
    const querylist = this.QUERY_KEY.Fuel_Master_LIST;

    try {
      const operation = graphqlOperation(getFuelMasterQueries.query, {
        nextToken: nextToken,
          limit: limit
      });

      const response = await API.graphql(operation) as GraphQLResult; 

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching Fuel Card request status:', error);
      throw error;
    }
  }

  public async createFuelCardDetails(
    createdObj: any
  ): Promise<InputFuelDetails> {
    const querylist = this.QUERY_KEY.Fuel_Card_Detail_CREATE;
    try {
      const operation = graphqlOperation(updateFuelMasterQueries.mutation, {

        employee_id: createdObj,
        employee_name: createdObj,
        fuel_card_id: createdObj,
        assigned_date: createdObj,

        // fuel_card_attachments: createdObj,
        status: AppConstants.REQUEST_STATUS.UNASSIGN,

        created_date: `${this.created_date}`,
        updated_date: `${this.updated_date}`,
      });

      // const response: GraphQLResult<{
      //   querylist: InputFuelDetails;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in create fuel master card.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching create fuel master card request status:',
        error
      );
      throw error;
    }
  }

  public async updateFuelCardDetails(
    updateObj: any
  ): Promise<InputFuelDetails> {
    const querylist = this.QUERY_KEY.Fuel_Card_Detail_UPDATE;
    try {
      const operation = graphqlOperation(updateFuelMasterQueries.mutation, {

        employee_id: updateObj,
        employee_name: updateObj,
        fuel_card_id: updateObj,
        assigned_date: updateObj,

        // fuel_card_attachments: createdObj,
        status: AppConstants.REQUEST_STATUS.UNASSIGN,

       // created_date: `${this.created_date}`,
        updated_date: `${this.updated_date}`,
      });

      // const response: GraphQLResult<{
      //   querylist: InputFuelDetails;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in create fuel master card.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching create fuel master card request status:',
        error
      );
      throw error;
    }
  }

  public async filterByFuelCard(status: string): Promise<FuelMasterModel> {
    const querylist = this.QUERY_KEY.Fuel_Master_LIST;
    // console.log('queryExplorer', queryExplorer);
    try {
      const operation = graphqlOperation(filterByFuelMasterQueries.query, {
        status: status,
      });

      // const response: GraphQLResult<{
      //   querylist: FuelMasterModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in filter from fuel master card.'
        );
      }
    } catch (error) {
      console.error('Error fetching filter fuel card:', error);
      throw error;
    }
  }

  public async  findFuelCardByCardNumber(cardNumber: string): Promise<FuelMasterModel> {
    const querylist = this.QUERY_KEY.Fuel_Master_LIST;
    // console.log('queryExplorer', queryExplorer);
    try {
      const operation = graphqlOperation(filterByFuelMaster.query, {
        status: 'ASSIGN',
        card_number: cardNumber,
      });

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        const returnResponse: any = response.data;
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in filter from fuel master card.'
        );
      }
    } catch (error) {
      console.error('Error fetching filter fuel card:', error);
      throw error;
    }
  }

  public async updateFuelMasterCardStatus(
    createdObj: any
  ): Promise<InputFuelDetails> {
    const querylist = this.QUERY_KEY.Fuel_Master_UPDATE;
    try {
      const operation = graphqlOperation(updateFuelMasterStatusQueries.mutation, {
        id: createdObj.id,
        status: AppConstants.REQUEST_STATUS.INACTIVE,
        updated_date: `${this.updated_date}`,
      });

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in create fuel master card.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching create fuel master card request status:',
        error
      );
      throw error;
    }
  }

  public async createFuelCardCredit(
    createdObj: any
  ): Promise<InputFuelCredits> {
    const querylist = this.QUERY_KEY.Fuel_Credit_CREATE;
    try {
      const operation = graphqlOperation(createFuelCreditQueries.mutation, {
        ...createdObj,
        created_date: `${this.created_date}`,
        updated_date: `${this.updated_date}`,
      });

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        const returnResponse: any = response.data;
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in create fuel master card.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching create fuel master card request status:',
        error
      );
      return null;
    }
  }

  public async getAllFuelCardCredit(nextToken:string | null,limit): Promise<FuelCreditModel> {
    const querylist = this.QUERY_KEY.Fuel_Credit_LIST;

    try {
      const operation = graphqlOperation(getFuelCreditQueries.query, {
        nextToken: nextToken,
          limit: limit
      });

      const response = await API.graphql(operation) as GraphQLResult; 

      console.log('Response:', response); // Log the entire response

      if (response.data) {

        const returnResponse: any = response.data;
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching Fuel Card request status:', error);
      return null;
    }
  }

  setFuelCardCreditData(data) {
    this.fuelCardCreditData.next(data);
  }


  public async updateFuelCardCredit (
    createdObj: any
  ): Promise<InputFuelCredits> {
    const querylist = this.QUERY_KEY.Fuel_Credit_UPDATE;
    try {
      const operation = graphqlOperation(updateFuelCreditQueries.mutation, {
        ...createdObj,
        updated_date: `${this.updated_date}`,
      });


      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        const returnResponse: any = response.data;
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in create fuel master card.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching create fuel master card request status:',
        error
      );
      return null;
    }
  }

  triggercreditEmail(payload: any) {
    this.httpClient.post(this.basUrl + "/fuelcardcreditEmail/", payload).subscribe((res) => {
      console.log("sendMail", res);
    });
  }
}
